export const CLASSIFICATIONS = [
  { value: '10mm_aggregate', label: '10mm Aggregate' },
  { value: '20mm_aggregate', label: '20mm Aggregate' },
  { value: '40mm_aggregate', label: '40mm Aggregate' },
  { value: 'sand',           label: 'Sand / M-Sand' },
  { value: 'dust',           label: 'Stone Dust' },
  { value: 'empty',          label: 'Empty Truck' },
  { value: 'mixed',          label: 'Mixed Load' },
];

export const STATUS_CONFIG = {
  ACTIVE:              { bg: '#E6F1FB', color: '#0C447C', label: 'In Yard' },
  PENDING_TARE_WEIGHT: { bg: '#E6F1FB', color: '#0C447C', label: 'Awaiting Tare Weight' },
  PENDING_LOADING:     { bg: '#FAEEDA', color: '#633806', label: 'Loading / Awaiting Gross Weight' },
  PENDING_CHALLAN:     { bg: '#F3E8FF', color: '#5B21B6', label: 'Awaiting Billing' },
  // Challan and payment are independent steps that can happen in either order,
  // so PENDING_CHALLAN resolves to one of these three for display (the backend
  // sends it as displayStatus — see /transactions/in-progress).
  NEEDS_CHALLAN:              { bg: '#F3E8FF', color: '#5B21B6', label: 'Awaiting Challan' },
  NEEDS_PAYMENT:              { bg: '#FCE4EC', color: '#9D174D', label: 'Awaiting Payment' },
  NEEDS_CHALLAN_AND_PAYMENT:  { bg: '#F3E8FF', color: '#5B21B6', label: 'Awaiting Challan + Payment' },
  PENDING_EXIT:        { bg: '#FDECC8', color: '#7A4B06', label: 'Awaiting Exit' },
  PENDING_REVIEW:      { bg: '#FAEEDA', color: '#633806', label: 'Pending Review' },
  APPROVED:            { bg: '#EAF3DE', color: '#27500A', label: 'Approved' },
  COMPLETED:           { bg: '#EAF3DE', color: '#27500A', label: 'Completed' },
  DENIED:              { bg: '#FCEBEB', color: '#791F1F', label: 'Denied' },
  REJECTED:            { bg: '#FCEBEB', color: '#791F1F', label: 'Rejected' },
};

export function formatTime(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('en-IN', {
    day: '2-digit', month: 'short',
    hour: '2-digit', minute: '2-digit', hour12: true,
  });
}

export function formatPlate(plate) {
  return (plate || '').toUpperCase().trim();
}

export function getConfidenceColor(score) {
  if (score >= 90) return '#639922';
  if (score >= 70) return '#BA7517';
  return '#E24B4A';
}
